<template>
  <div>
    <template v-if="isEdit">
      <template>
        <template>
          <div class="caption">
            {{ $t('Realname') }}
          </div>

          <div class="form-control">
            <input type="text" v-model="info.name" maxlength="40"/>
          </div>
        </template>

        <template>
          <div class="caption">
            {{ $t('Postcode') }}
          </div>

          <div class="form-control">
            <input type="text" v-model="info.postcode" maxlength="40"/>
          </div>
        </template>

        <template>
          <div class="caption">
            {{ $t('Province') }}
          </div>

          <div class="form-control">
            <input type="text" v-model="info.province" maxlength="40"/>
          </div>
        </template>

        <template>
          <div class="caption">
            {{ $t('District') }}
          </div>

          <div class="form-control">
            <input type="text" v-model="info.district" maxlength="40"/>
          </div>
        </template>

        <template>
          <div class="caption">
            {{ $t('Subdistrict') }}
          </div>

          <div class="form-control">
            <input type="text" v-model="info.subDistrict" maxlength="40"/>
          </div>
        </template>

        <template>
          <div class="caption">
            {{ $t('address_house_no') }}
          </div>

          <div class="form-control" :class="{ 'has-error': errors.has('address_house_no') }" style="padding: 5px">
            <textarea
              name="address_house_no"
              id="address_house_no"
              rows="3"
              maxlength="200"
              :data-vv-as="$t('address_house_no')"
              class="form-control"
              v-model="info.address"
              v-validate="'required'"
            ></textarea>
            <span class="error--text caption" v-show="errors.has('address_house_no')">{{
              errors.first('address_house_no')
            }}</span>
          </div>
        </template>

        <template>
          <div class="caption">
            {{ $t('Tel.') }}
          </div>

          <div class="form-control">
            <input type="tel" maxlength="10" v-model="info.tel" />
          </div>
        </template>
      </template>

      <v-btn outline small color="primary" @click="cancelChange">
        {{ $t('cancel') }}
      </v-btn>
      <v-btn depressed small color="primary" @click="saveChange">
        {{ $t('Save') }}
      </v-btn>
    </template>

    <template v-else>
      <specialtext :text="value"></specialtext>
      <!-- <nl2br tag="span" :text="value" :title="value" style="word-wrap: break-word;" /> -->
      <div style="display: inline-block">
        <v-btn flat fab small color="primary" class="ma-0" @click="isEdit = true">
          <v-icon>edit</v-icon>
        </v-btn>
        <template v-if="hasCopy">
          <v-tooltip v-model="showCopy" bottom color="success">
            <template v-slot:activator="{}">
              <v-btn
                flat
                fab
                small
                class="ma-0"
                color="primary"
                v-clipboard:copy="value"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError"
              >
                <v-icon>file_copy</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Copied') }}</span>
          </v-tooltip>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
// import Nl2br from 'vue-nl2br'
import specialtext from '@/components/elements/specialtext'
import { cloneDeep } from 'lodash'
export default {
  props: ['value', 'hasCopy'],
  components: {
    // Nl2br,
    specialtext
  },
  data() {
    return {
      isEdit: false,
      info: {
        name: null,
        address: null,
        subDistrict: null,
        district: null,
        province: null,
        postcode: null,
        tel: null
      },
      showCopy: false
    }
  },
  created() {},
  mounted() {
    this.formatInfo()
    this.cached_info = cloneDeep(this.info)
  },
  methods: {
    formatInfo() {
      try {
        var info = this.value.split(' , ')
        if (info.length > 3) {
          this.info.name = info[0].trim()
          this.info.address = info[1].trim()
          this.info.subDistrict = info[2].trim()
          this.info.district = info[3].trim()
          this.info.province = info[4].trim()
          this.info.postcode = info[5].trim()
          this.info.tel = info[info.length - 1].trim()
          delete info[0]
          delete info[info.length - 1]
          // this.info.address = info.join(' ').trim()
        } else {
          this.info.name = info[0].trim()
          this.info.address = info[1].trim()
          this.info.tel = info[info.length - 1].trim()
          delete info[0]
          delete info[info.length - 1]
          // this.info.address = info.join(' ').trim()
        }
      } catch (error) {
        this.info.address = this.value
      }
    },
    cancelChange() {
      this.isEdit = false
      this.info = cloneDeep(this.cached_info)
      const info = [
        this.info.name,
        this.info.address,
        this.info.subDistrict,
        this.info.district,
        this.info.province,
        this.info.postcode,
        this.info.tel
      ]
      this.$emit('input', info.join(' , '))
      this.$emit('edited')
    },
    saveChange: function() {
      this.isEdit = false
      const info = [
        this.info.name,
        this.info.address,
        this.info.subDistrict,
        this.info.district,
        this.info.province,
        this.info.postcode,
        this.info.tel
      ]
      this.cached_info = cloneDeep(this.info)
      this.$emit('input', info.join(' , '))
      this.$emit('edited')
    },
    onCopy() {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onCopyError() {}
  },
  watch: {
    value: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.formatInfo()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/EditAddress.vue